export const BASE_PATH="/data/digitvcards"
export const COLLECTIONS = {
  ADMINS: `${BASE_PATH}/admins`,
  USERS: `${BASE_PATH}/users`,
  AGENCIES: `${BASE_PATH}/agencies`,
  AGENCY_MEMBERS: `${BASE_PATH}/agencymembers`,
  CORPORATES: `${BASE_PATH}/corporates`,
  CORPORATE_MEMBERS: `${BASE_PATH}/corporatemembers`, 
  CARDS: `${BASE_PATH}/cards`,
  DIGITAL_CARDS: `${BASE_PATH}/digitalcards`,
  CATEGORY: `${BASE_PATH}/category`,
  LISTING: `${BASE_PATH}/listing`,
  WISHLIST: `${BASE_PATH}/wishlist`,
  BOOKMARKS: `${BASE_PATH}/bookmarks`,
  EMAIL: `${BASE_PATH}/email`,
} as const;
